<template>
  <!--
  Todo:
  - Tages Einstellung Speichern (state of calender) ?
  - Text für Overview
  - Handbuch Endpoint ändern
   -->
  <v-app>
    <navigation v-if="!$route.meta.hideNavigation" :mobile="$vuetify.breakpoint.mdAndDown" />
    <v-main>
      <router-view/>
    </v-main>
    <message-bar />
    <cookie-consent />
    <device-status  v-if="!$route.meta.hideNavigation" />
    <sync-service v-if="!$route.meta.hideNavigation" />
    <status-updater v-if='$route.meta.requiresAuthentication'/>
    <footer-bar />
  </v-app>
</template>


<script>
import { mapState } from 'vuex';
import CookieConsent from './components/CookieConsent';
import Navigation from './components/Navigation';
import MessageBar from './components/MessageBar';
import FooterBar from './components/FooterBar';
import DeviceStatus from './components/DeviceStatus';
import SyncService from './components/SyncService';
import StatusUpdater from './components/StatusUpdater';

export default {
  name: 'App',
  data: () => ({
  }),
  components: {
    CookieConsent,
    Navigation,
    MessageBar,
    FooterBar,
    DeviceStatus,
    SyncService,
    StatusUpdater,
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user
    })
  }
};
</script>
